import * as React from 'react';
import { useEffect, useState, useRef } from "react";
import { getEnv } from "../helpers/env.ts";
import useClickOutside from "../helpers/useClickOutside";
import type { MenuData } from "../rest.interface";
import MenuItem, { filterMenuItemsByParent } from "./menuItem";
import clsx from 'clsx';
import { useWindowScroll } from "@uidotdev/usehooks";

interface Props {
	menu: MenuData,
	pathname: string,
}

function Header({menu, pathname, ...otherProps}: Props) {
	const refHeader = useRef<HTMLHeadingElement>(null);
	const refMobileMenu = useRef<HTMLDivElement>(null);
	const [opened, setOpened] = useState<boolean>(false);
	useClickOutside(refMobileMenu, () => setOpened(false));

	const [{ x, y }] = useWindowScroll();
	const [isSticky, setIsSticky] = useState<boolean>(false);

	if (isSticky === false && y > 10) {
		setIsSticky(true);
	}
	if (isSticky === true && y == 0) {
		setIsSticky(false);
	}

	useEffect(() => {
		setOpened(false);
	}, [pathname]);

	let logo = <h2 className={clsx("logo my-4 md:my-5 transition-all", isSticky ? 'small' : 'lg:my-6 xl:my-7')}>
		{getEnv('PUBLIC_SITE_NAME') ? getEnv('PUBLIC_SITE_NAME').toString() : ''}
	</h2>;

	if (pathname !== '/') {
		logo = <a href="/" className="inline-block">{logo}</a>;
	} else {
		logo = <span className="inline-block">{logo}</span>;
	}

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		{/*<Dump {...menu}/>*/}
		{/*<div className="fixed top-0 left-0 z-50">*/}
		{/*	<Dump value={y}/>*/}
		{/*</div>*/}

		<div
			id="headerWrapper"
			className={clsx("-top-[1px] sticky  transition-all ease-mine duration-500 bg-primary-200 text-white", isSticky ? "z-20" : "z-40")}
			{...otherProps}
			ref={refHeader}
		>
			<header className={clsx("max-w-screen-2xl mx-auto px-8 md:px-20 xl:px-24 2xl:px-32")}>
				<div className={clsx("flex sm:flex-wrap items-center gap-x-8 justify-between lg:justify-center", isSticky ? "" : '')}>
					<a
						href="#mobileMenu"
						className={clsx("iconHamburger block lg:hidden shrink-0 my-2", opened && "iconHamburgerOpened")}
						aria-label="Menu"
						title="Menu"
					    onClick={() => setOpened((opened) => { return !opened; })}
					>
						<span/>
						<span/>
						<span/>
					</a>

					{logo}

					<div className="flex-grow"/>

					<div
						className={clsx("hidden lg:block", !isSticky ? "" : "order-2")}>
						<menu className="mainMenu">
							{rootMenuItems && rootMenuItems.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									className={clsx(isSticky && 'isSticky')}
									index={index}
									siblingsCount={rootMenuItems.length - 1}
								/>;
							})}
						</menu>
					</div>
				</div>
			</header>
		</div>

		<div className={clsx(
			"fixed top-0 right-0 z-40 h-full w-full transition-all duration-300",
			opened ? 'bg-secondary-300/50 visible backdrop-blur-sm' : 'backdrop-blur-none bg-secondary-300/0 invisible'
		)}/>

		<div id="mobileMenu" className={clsx(
			"fixed top-0 right-0 z-50 h-full w-full overflow-y-auto overscroll-y-none transition duration-500",
			opened ? 'translate-x-0' : 'translate-x-full'
		)}>
			<div className="float-right relative min-h-full w-[80%] bg-primary-200 text-white p-8 sm:p-12 shadow-xl" ref={refMobileMenu}>
				<a href="#" className="iconOpenClose iconOpened absolute top-7 right-8 sm:right-12" onClick={() => setOpened(false)} title="X"></a>
				<div className="pb-4 mb-8 border-b border-white">
					<div className="inline-block">
						<div className="logo small"/>
					</div>
				</div>

				<menu className="mobileMenu">
					{rootMenuItems && rootMenuItems.map((item, index) => {
						return <MenuItem
							menu={menu}
							item={item}
							key={'item' + index}
							pathname={pathname}
							index={index}
							siblingsCount={rootMenuItems.length - 1}
						/>;
					})}
				</menu>
			</div>
		</div>
	</>);
}

export default Header;
